import { jsx, jsxs } from "react/jsx-runtime";
import { normalizePositionByRangeLength } from "@teselagen/range-utils";
import getXStartAndWidthOfRangeWrtRow from "./getXStartAndWidthOfRangeWrtRow";
import React, { useMemo } from "react";
import calculateTickMarkPositionsForGivenRange from "../utils/calculateTickMarkPositionsForGivenRange";
import { divideBy3 } from "../utils/proteinUtils";
import { view } from "@risingstack/react-easy-state";
import { getVisibleStartEnd } from "../utils/getVisibleStartEnd";
const Axis = function(props) {
  const {
    row,
    tickSpacing,
    bpsPerRow,
    charWidth,
    annotationHeight,
    marginTop,
    sequenceLength,
    showAxisNumbers = true,
    getGaps,
    scrollData,
    isProtein,
    style,
    isLinearView
  } = props;
  const noRows = row.start === 0 && row.end === 0;
  const tickMarkPositions = useMemo(() => {
    if (noRows) return [];
    return calculateTickMarkPositionsForGivenRange({
      tickSpacing,
      range: row,
      sequenceLength,
      isProtein
    }).map((tickMarkPosition) => {
      const gaps = getGaps ? getGaps(tickMarkPosition).gapsBefore : 0;
      const xCenter = (tickMarkPosition - (isProtein ? 1 : 0) + gaps) * charWidth + charWidth / 2;
      return {
        tickMarkPosition,
        xCenter
      };
    });
  }, [
    noRows,
    tickSpacing,
    row.start,
    row.end,
    sequenceLength,
    isProtein,
    charWidth
  ]);
  if (noRows) {
    return null;
  }
  const { xStart, width } = getXStartAndWidthOfRangeWrtRow({
    row,
    range: row,
    charWidth,
    sequenceLength,
    ...getGaps ? getGaps(row) : {}
  });
  const xEnd = xStart + width;
  let visibleStart, visibleEnd;
  if (scrollData) {
    const val = getVisibleStartEnd({
      scrollData,
      width: sequenceLength * charWidth
    });
    visibleStart = val.visibleStart - 400;
    visibleEnd = val.visibleEnd + 400;
  }
  const yStart = 0;
  const tickMarkSVG = [];
  tickMarkPositions.forEach(function({ tickMarkPosition, xCenter }, i) {
    if (scrollData && !(xCenter < visibleEnd && xCenter > visibleStart)) return;
    tickMarkSVG.push(
      /* @__PURE__ */ jsx(
        "rect",
        {
          className: "veAxisTick",
          "data-test": tickMarkPosition + 1,
          x: xCenter,
          width: 1,
          height: 5
        },
        "axisTickMarkPath " + i + " " + tickMarkPosition
      )
    );
    if (showAxisNumbers) {
      const position = normalizePositionByRangeLength(
        row.start + tickMarkPosition,
        sequenceLength
      ) + (isProtein ? 0 : 1);
      const positionLength = position.toString().length * 4;
      const textInner = divideBy3(position + (isProtein ? 1 : 0), isProtein);
      let x = xCenter;
      if (!isLinearView) {
        x = i === 0 ? Math.max(positionLength, xCenter) : i === tickMarkPositions.length - 1 ? Math.min(bpsPerRow * charWidth - positionLength, xCenter) : xCenter;
      }
      if (i === tickMarkPositions.length - 1) {
        x = Math.min(x, xEnd - positionLength / 2);
      }
      tickMarkSVG.push(
        /* @__PURE__ */ jsx(
          "text",
          {
            "data-tick-mark": textInner,
            fill: "black",
            x,
            y: annotationHeight,
            style: { textAnchor: "middle", fontSize: 10, fontFamily: "Verdana" },
            children: textInner
          },
          "axisTickMarkText " + i + " " + tickMarkPosition
        )
      );
    }
  });
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: "veRowViewAxis veAxis",
      height: annotationHeight,
      width: Math.max(0, width),
      style: { marginTop, overflow: "visible", display: "block", ...style },
      children: [
        tickMarkSVG,
        /* @__PURE__ */ jsx(
          "path",
          {
            className: "veAxisLine",
            d: "M" + xStart + "," + yStart + " L" + xEnd + "," + yStart,
            stroke: "black"
          }
        )
      ]
    }
  );
};
export default view(Axis);
